import React from "react";
import { observer, inject } from "mobx-react";
import { Row, Col, Table, Button, Form, Card } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { RouteComponentProps, Link } from "react-router-dom";
import DatePicker, { registerLocale } from "react-datepicker";
import ru from 'date-fns/locale/ru';
import { formatDate, formatMoney } from "../../../common/Formatting";
import { TableFooterPager } from "../../../common/UI/TableFooterPager";
import { AcceptancesStore } from "../../../stores";
import { STORE_ACCEPTANCES } from "../../../constants";
import { TablePageHeader } from "../../../components/TablePageHeader";
registerLocale('ru', ru)

interface IProps {
    history: any,
    [STORE_ACCEPTANCES]: AcceptancesStore
}

interface IState {
    currentPage: number,
    filterFormIsOpened: boolean,
    dateFrom?: Date,
    dateTo?: Date,
    newAcceptanceModalIsOpened: boolean
}


type Props = IProps & RouteComponentProps<{ page: string }>;

@inject(STORE_ACCEPTANCES)
@observer
export class AcceptancesPage extends React.Component<Props, IState> {
    constructor(props: Props) {
        super(props);
        const page = parseInt(this.props.match.params.page) || 1;
        this.state = {
            currentPage: page,
            filterFormIsOpened: false,
            newAcceptanceModalIsOpened: false
        };
    }

    acceptancesStore = (this.props as any)[STORE_ACCEPTANCES] as AcceptancesStore;

    loadData = () => {
        this.acceptancesStore.loadAcceptances(this.state.currentPage, this.state.dateFrom, this.state.dateTo);
    }

    componentDidMount() {
        this.loadData();
    }

    componentDidUpdate(prevProps: Props, prevState: IState, snapshot: any) {
        const prevPage = parseInt(prevProps.match.params.page) || 1;
        const page = parseInt(this.props.match.params.page) || 1;

        if (prevPage != page) {
            this.setState({
                currentPage: page
            }, () => {
                this.loadData();
            })
        }
    }


    private toggleFilter = () => {
        const previousState = this.state.filterFormIsOpened;
        this.setState({
            filterFormIsOpened: !previousState
        });
    }
    private clearFilter = () => {
        this.setState({
            dateFrom: undefined,
            dateTo: undefined
        });
        localStorage.removeItem("acceptancesFilter");
    }

    private changeFilter = (name: string, value: any) => {

        (this as any).setState({
            [name]: value
        }, () => {
            // this.saveFilterToLocalStorage();
        });
    }

    render() {
        return [
            <TablePageHeader header="Приемки" reload={this.loadData} key="1">
                <Form inline onSubmit={(e: any) => {
                    e.preventDefault();
                    this.loadData();
                }}>

                    <Button type="button" size="sm" onClick={() => {
                        this.props.history.push("/deliverypoint/createacceptance")
                    }}>
                        <FontAwesomeIcon icon="plus" />
                        {' '}
                        Приемка
                    </Button>
                    <Button type="button" size="sm" variant="secondary" active={this.state.filterFormIsOpened}
                        style={{ marginLeft: "15px" }} onClick={this.toggleFilter}>
                        Фильтр
                    </Button>
                </Form>

            </TablePageHeader>,
            this.state.filterFormIsOpened ?
                <Row key="filter">
                    <Col sm="12">
                        <Card bg="light" >
                            <Card.Body>
                                <Form>
                                    <Row>
                                        <Col sm="2">
                                            <Button variant="primary" size="sm" onClick={this.loadData}>Найти</Button>
                                            <Button
                                                variant="secondary"
                                                size="sm" style={{ marginLeft: "20px" }}
                                                onClick={this.clearFilter}>
                                                Очистить
                                            </Button>
                                        </Col>
                                        <Col sm="4">
                                            <Form.Group controlId="filterForm.DateFrom">
                                                <Form.Label>Дата с</Form.Label>
                                                <div>
                                                    <DatePicker
                                                        className="form-control form-control-sm"
                                                        locale="ru"
                                                        dateFormat="dd-MM-yyyy"
                                                        monthsShown={2}
                                                        openToDate={(new Date()).addMonth(-1)}
                                                        name="dateFrom"
                                                        autoComplete="off"
                                                        onChange={(date: Date | null) => {
                                                            this.changeFilter("dateFrom", date || undefined)
                                                        }}
                                                        selected={this.state.dateFrom}
                                                    />
                                                </div>
                                            </Form.Group>
                                            <Form.Group controlId="filterForm.DateTo">
                                                <Form.Label>Дата по</Form.Label>
                                                <div>
                                                    <DatePicker
                                                        className="form-control form-control-sm"
                                                        locale="ru"
                                                        dateFormat="dd-MM-yyyy"
                                                        maxDate={new Date()}

                                                        onChange={(date: Date | null) => {
                                                            if (date != undefined) {
                                                                date.setHours(23);
                                                                date.setMinutes(59);
                                                                date.setSeconds(59);
                                                            }
                                                            this.changeFilter("dateTo", date || undefined)
                                                        }}
                                                        selected={this.state.dateTo}
                                                    />
                                                </div>
                                            </Form.Group>
                                        </Col>
                                        <Col sm="2"></Col>
                                    </Row>
                                </Form>
                            </Card.Body>
                        </Card>
                        <br />
                    </Col>
                </Row> : [],
            <Row key="2">
                <Col sm={12}>
                    <Table bordered striped className="table-xxs">
                        <thead>
                            <tr>
                                <th className="text-center">#</th>
                                <th className="text-center">Дата создания</th>
                                <th className="text-center">Менеджер</th>
                                <th className="text-center">Количество позиций</th>
                                <th className="text-center">Сумма</th>
                                <th>Комментарий</th>
                            </tr>
                        </thead>
                        <TableFooterPager
                            columnsCount={9}
                            page={this.acceptancesStore.currentPage}
                            totalCount={this.acceptancesStore.totalOrdersCount}
                            pageSize={40}
                            move={"/sales/acceptances"} />
                        <tbody>
                            {this.acceptancesStore.acceptances.map((w, index) => <tr key={index}>
                                <td className="text-center">{w.id}</td>
                                <td className="text-center">{formatDate(w.dateCreate)}</td>
                                <td className="text-center">{w.userName}</td>
                                <td className="text-center">{w.positionsCount}</td>
                                <td className="text-center">{formatMoney(w.summ)}</td>
                                <td>{w.comment}</td>
                            </tr>)}
                        </tbody>
                    </Table>
                </Col>
            </Row>
            // <ReleaseModal
            //     isOpened={this.state.releaseModalIsOpened}
            //     positions={this.demandsStore.demands.filter(w => this.state.selectedPositionsIds.indexOf(w.id) > -1)}
            //     cancelCallback={this.closeReleaseModal}
            //     confirmCallback={() => alert("Confirmed")}
            // />
        ]
    }

}